import { RouteConfig } from 'aurelia-router';
import fm from 'front-matter';

const SOURCE_BASE = 'https://tfs.essette.com/tfs/Essette/Essette/AppDev/_versionControl?path=$/Essette/EssetteSuite/Template.4.0.0/GUI/Hms.Essette.Application';
const PATH_MAP = new Map([
  ['components', 'elements']
]);

export class DocViewModel {

  doc!: string;
  data: any;

  async activate({ doc }: any, config: RouteConfig) {
    this.doc = doc;
    // @ts-ignore
    const markup = await System.import(`app/docs/docs/${doc}.html!text`);
    const { attributes } = fm(markup);
    this.data = attributes;
  }

  getTsSrc(doc: string) {
    const [type, element] = doc.split('/');
    return `${SOURCE_BASE}/wwwroot/app/shared/${PATH_MAP.get(type)}/${element}.ts`;
  }

  getHtmlSrc(doc: string) {
    const [type, element] = doc.split('/');
    return `${SOURCE_BASE}/wwwroot/app/shared/${PATH_MAP.get(type)}/${element}.html`;
  }

  getScssSrc(doc: string) {
    const [type, element] = doc.split('/');
    return `${SOURCE_BASE}/scss/${type}/_${element}.scss`;
  }
}
